import {mark, types as metrics} from '@servicenow/ui-metrics';

const performanceApiExists =
	performance &&
	typeof performance.mark === 'function' &&
	typeof performance.measure === 'function';
let {__ENABLE_NOW_UI_PERFORMANCE__} = window;
let uiPerfEnabled =
	process.env.NODE_ENV === 'performance' ||
	process.env.NODE_ENV === 'test' ||
	__ENABLE_NOW_UI_PERFORMANCE__;

try {
	delete window.__ENABLE_NOW_UI_PERFORMANCE__;

	Object.defineProperty(window, '__ENABLE_NOW_UI_PERFORMANCE__', {
		configurable: true,
		get() {
			return __ENABLE_NOW_UI_PERFORMANCE__;
		},
		set(value) {
			__ENABLE_NOW_UI_PERFORMANCE__ = value;
			uiPerfEnabled =
				process.env.NODE_ENV === 'performance' || process.env.NODE_ENV === 'test' || value;
		}
	});
} catch (e) {
	// fail silently
}

export default function measure(fn, host, marker, interactionId, options) {
	if (!performanceApiExists) return fn();

	mark(host, interactionId, metrics.RENDER_START, options);

	let startMarker;
	if (uiPerfEnabled) {
		startMarker = `${marker}-start`;
		performance.mark(startMarker);
	}
	fn();
	mark(host, interactionId, metrics.RENDER_END, options);
	if (uiPerfEnabled) performance.measure(marker, startMarker);
}
